export default __webpack_public_path__ + "static/media/sp-slides.595893aa.jpg";